import { useTracking } from "./js/tracking"
import { useWebhookForms } from "./js/webhook-forms"
import { useInfiniteScroll } from "./js/infinite-scroll"

useTracking(document)
useWebhookForms(document)
useInfiniteScroll(document)